import type { ReactNode } from 'react';

export const symbol_water_full: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M444-610q-60 0-119 19.5T218-536l44 396h436l47-430h-48q-37 0-68-5.3-31-5.29-85-20.7-25-7-49.5-10.5T444-610Zm-233 7q51-32 111.5-49T444-670q30 0 59.5 4t56.5 12q51.13 14 78.23 19 27.09 5 57.77 5h56l21-190H187l24 217Zm51 523q-23 0-40.34-14.93Q204.31-109.86 202-133l-74-673q-3-30 17.11-52 20.1-22 49.89-22h570q29.79 0 49.89 22Q835-836 832-806l-74 673q-2.31 23.14-19.66 38.07Q721-80 698-80H262Zm182-60h254-436 182Z"
		/>
	</svg>
);
